import { render } from "./OrderItemRevenueTable.vue?vue&type=template&id=3f3f625d"
import script from "./OrderItemRevenueTable.vue?vue&type=script&lang=js"
export * from "./OrderItemRevenueTable.vue?vue&type=script&lang=js"

import "./OrderItemRevenueTable.vue?vue&type=style&index=0&id=3f3f625d&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QMarkupTable,QChip,QTooltip});
